import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../lib/domain';
import Title from 'antd/lib/typography/Title';
import { Table, Button, message, Spin, Modal, Divider, Popconfirm, Row, Tabs, InputNumber, Select, Input } from 'antd';
import { showErrorInNotification, defaultDateFormat, formatMoney } from '../lib/util';
import moment from 'moment'
import CustomDateRangePicker from './custom_date_range';
import ErrorWrapper from '../lib/error_wrapper';
import FilterFixedInput from './filter_fixed_input';
import NetworkSelect from '../lib/ui/network_select';
import { TabButton, CustomButton } from './basic_items';
import { TransactionColumnsBasic } from './transaction_columns';
import { TransactionReconcileItem } from './transaction_reconcile_item';
import { MoreHorizOutlined } from '@material-ui/icons';
import ModalTransactionDetail from './modal_transaction_detail';
const reconciled_cols = ({ onViewDetailClicked }) => [
  {
    // title: "Type",
    dataIndex: "type",
    width: 50,
    key: 'type',
    render: (value) => <div style={{ backgroundColor: value == 'C' ? '#4062BB' : '#4E937A' }} className='dr-cr-text'>
      {value}
    </div>
  },
  {
    title: "Txn Date",
    dataIndex: "txn_date",
    width: 120,
    key: 'txn_date'
  }, {
    title: "Tran ID",
    dataIndex: "transaction_id",
    width: 100,
    key: 'trgroyuansaction_id'
  }, {
    title: "Particular",
    dataIndex: "description",
    key: 'description'
  }, {
    title: "Amount",
    dataIndex: "amount",
    width: 120,
    key: 'amount',
    render: (amount) => formatMoney(amount)
  },
  {
    title: "",
    dataIndex: "id",
    width: 50,
    key: 'action',
    render: (id) => <Button type='link' onClick={() => {
      typeof onViewDetailClicked === 'function' && onViewDetailClicked(id)
    }}>View</Button>
  }
]
class TransactionPeersBatchReconcile extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false
    }
    this.main_params = {
      reconciler_id: this.props.reconciler_id || "",
      transaction_id: this.props.transaction_id || ""
    }

    this.approve_manually = RESTExecutor.post().config({
      label: 'approve_manually'
    }).callbacks((success) => {
      this.setState({ loading: false })
      message.success("Approved Successfully")
      typeof this.props.onRefresh === 'function' && this.props.onRefresh()
    }, (error) => {
      this.setState({ loading: false })

      showErrorInNotification(error)
    }).connect(props.domains.reconciliation);


    this.reject_manually = RESTExecutor.post().config({
      label: 'reject_manually'
    }).callbacks((success) => {
      this.setState({ loading: false })
      message.success("Rejected Successfully")
      typeof this.props.onRefresh === 'function' && this.props.onRefresh()
    }, (error) => {
      this.setState({ loading: false })
      showErrorInNotification(error)
    }).connect(props.domains.reconciliation);

  }

  rejectData = () => {
    this.setState({ loading: true });

    this.reject_manually.forId(this.props.reconciler.id).execute({
      txn_ids: [this.props.reconciler.reconciled_id]
    });

  }

  approveData = () => {
    this.setState({ loading: true });
    this.approve_manually.forId(this.props.reconciler.reconciled_id).execute({
      txn_ids: [this.props.reconciler.reconciled_id]
    });

  }
  render() {
    let reconciler = this.props.reconciler || {};
    let rules = reconciler.rules || [];
    let done = this.props.reconciled;
    let approve_manually_resp = this.approve_manually.response();
    let reject_manually_resp = this.reject_manually.response();

    return (
      <Spin spinning={this.state.loading} tip='Processing....'>
        <div>
          <Modal
            visible={this.state.view_transaction_modal}
            width={'90%'}
            destroyOnClose
            footer={null}
            className='transaction-modal'
            centered
            onCancel={() => {
              this.setState({
                view_transaction_modal: false,
                view_transaction_id: null
              })
            }}
          >
            <ModalTransactionDetail
              isModal={true}
              onClose={() => {
                this.setState({
                  view_transaction_modal: false,
                  view_transaction_id: null
                })
              }}
              match={{
                params: {
                  transaction_id: this.state.view_transaction_id
                }
              }}
              transaction_id={this.state.view_transaction_id}
            />
          </Modal>
          {this.props.batch_id &&
            <BatchPeersView key={`${this.props.transaction_id}batch-${reconciler.id}`}
              transaction_id={this.props.transaction_id}
              reconciler_id={reconciler.id}
              reconciler={reconciler}
              onViewDetailClicked={(id) => {
                this.setState({
                  view_transaction_id: id,
                  view_transaction_modal: true
                })
              }}

            />}
          {done ? <div className='default-card' style={{ margin: 0, padding: 0, paddingTop: 8 }}>
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              paddingLeft: 10,
              paddingRight: 10,
              alignItems: 'center'
            }}>
              <span className='sub-heading-2'>RECONCILED FOR {reconciler.name}</span>
              <div style={{
                display: 'flex',
                alignItems: 'center'
              }}>
                {!reconciler.approved && <CustomButton
                  disabled={approve_manually_resp.fetching}
                  className='primary-btn'
                  onClick={() => {
                    this.approveData()
                  }}
                  label="APPROVE"
                />}
                <Popconfirm
                  placement="topRight"
                  title={`Are you sure you want to reject this reconciliation?`}
                  onConfirm={() => {
                    this.rejectData()
                  }}
                >
                  <CustomButton style={{ marginLeft: 12 }} className='danger-btn'
                    disabled={reject_manually_resp.fetching}

                    label="REJECT"
                  /></Popconfirm>
              </div>
            </div>
            <div style={{
              paddingLeft: 10,
              paddingRight: 10,
            }}>
              <Table
                scroll={{ x: true }}
                columns={TransactionColumnsBasic({
                  extra_actions: [
                    {
                      title: "",
                      dataIndex: "id",
                      width: 50,
                      key: 'action',
                      render: (id) => <Button type='link' onClick={() => {
                        this.setState({
                          view_transaction_id: id,
                          view_transaction_modal: true
                        })
                        // typeof onViewDetailClicked === 'function' && onViewDetailClicked(id)
                      }}>View</Button>
                    }
                  ]
                })}
                dataSource={[reconciler.reconciled_txn || {}]}
                size='small'
                className='main-table'
                bordered={false}
                pagination={false}
              />
            </div>

            <Divider className='bg-divider' style={{
              marginTop: 12, marginBottom: 12
            }} />

            <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              paddingLeft: 10,
              paddingRight: 10,
              alignItems: 'center'
            }}>
              <span className='sub-heading-2'>LOGS FOR {reconciler.name}</span>
            </div>
            <div style={{
              paddingLeft: 10,
              paddingRight: 10,
            }}>
              <Divider style={{
                marginTop: 12, marginBottom: 12
              }} />
              <Table
                scroll={{ x: true }}
                className='main-table'
                // title={() => {
                //   return <Title level={4} type='secondary'>Logs</Title>
                // }}

                columns={[
                  { title: "DATETIME", dataIndex: 'created_at', key: 'created_at' },
                  { title: "USERNAME", dataIndex: 'username', key: 'username' },
                  { title: "NAME", dataIndex: 'name', key: 'name' },
                  { title: "ACTION", dataIndex: 'action', key: 'action' }
                ]}
                dataSource={reconciler.logs || []}
                size='small'
                // className='customTable ant-table-small-noborder no-bg-table'
                bordered={false}
                pagination={false}
              />
            </div>

          </div> : <div className='default-card' style={{ margin: 0 }}>
              <Row type='flex' justify='space-between' style={{
                paddingLeft: 20,
                paddingRight:20,
                paddingTop: 12,

              }}>
                <span className='sub-heading-3'>
                  RECONCILIATION RULES
                </span>
                <CustomButton
                  style={{}}

                  onClick={() => {
                    // this.setState({
                    //   selected_id: null
                    // })
                  }} className='danger-btn'
                  label="Delete"
                />

              </Row>


              <Divider style={{
                marginTop: 12, marginBottom: 0
              }} />
              {/* <br></br> */}
              <Tabs className='rules-tab'>

                {rules.map((rule_item) => {
                  return <Tabs.TabPane key={rule_item.id} tab={rule_item.name}>
                    <RecommendedReconcileForTransaction
                      key={`${rule_item.id}rule`}
                      onViewDetailClicked={(id) => {
                        this.setState({
                          view_transaction_id: id,
                          view_transaction_modal: true
                        })
                      }}
                      rule_id={rule_item.id}
                      transaction_id={this.props.transaction_id}
                      reconciler={reconciler}
                      reconciled={done}
                      onRefresh={this.props.onRefresh}
                    />
                  </Tabs.TabPane>
                })}
                <Tabs.TabPane key='all' tab="ALL">
                  <UnclassifiedReconcilerForTransaction
                    key={'unclassified'}
                    onViewDetailClicked={(id) => {
                      this.setState({
                        view_transaction_id: id,
                        view_transaction_modal: true
                      })
                    }}
                    // rule_id={rule_item.id}
                    transaction_id={this.props.transaction_id}
                    reconciler={reconciler}
                    reconciled={done}
                    onRefresh={this.props.onRefresh}
                  />
                </Tabs.TabPane>
                <Tabs.TabPane key='manual' tab="Manual Reconcile">
                  <ManualReconcileForTransaction
                    amount={this.props.amount}
                    onViewDetailClicked={(id) => {
                      this.setState({
                        view_transaction_id: id,
                        view_transaction_modal: true
                      })
                    }}
                    reconciler_id={reconciler.id}
                    transaction_id={this.props.transaction_id}
                    reconciler={reconciler}
                    reconciled={done}
                    onRefresh={this.props.onRefresh}
                  />
                </Tabs.TabPane>
              </Tabs>
            </div>
          }

        </div>
      </Spin>
    );
  }
}

export default TransactionPeersBatchReconcile = withDomains(TransactionPeersBatchReconcile, "allData", "reconciliation");


class _UnclassifiedReconcilerForTransaction extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      filter_query: {
        reconciler_id: this.props.reconciler.id || "",
        source_id: this.props.reconciler.source_id,
        tran_id: this.props.transaction_id || "",
        per_page: 10,
        page: 1
      }
    }
    // this.main_params = {
    //   reconciler_id: this.props.reconciler.id || "",
    //   tran_id: this.props.transaction_id || ""
    // }

    this.list_recommended = RESTExecutor.list().config({
      label: 'recommended_for_unclassified',
      params: {
        ...this.state.filter_query
      }
    }).callbacks(() => { }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.reconciliation);

    this.reconcile_data = RESTExecutor.post().config({
      label: 'reconcile_manually'
    }).forId(this.props.reconciler.id).callbacks((success) => {
      this.setState({ loading: false })
      message.success("Reconciled Successfully")
      typeof this.props.onRefresh === 'function' && this.props.onRefresh()
    }, (error) => {
      this.setState({ loading: false })
      showErrorInNotification(error)
    }).connect(props.domains.reconciliation);





    // let reconciler = this.props.reconciler || {};
    // if (reconciler.type === 'their') {
    //   this.list_sources_fordatatype.forId(reconciler.our_data_type_id).execute();
    // } else {
    //   this.list_sources_fordatatype.forId(reconciler.their_data_type_id).execute();
    // }

  }

  reconcileData = () => {
    this.setState({ loading: true });
    let data = {};
    if (this.props.reconciler.type == 'our') {
      data = {
        their_id: `${this.state.selected_id}`,
        our_id: `${this.props.transaction_id}`,
        source_id: this.props.reconciler.source_id
      }
    } else {
      data = {
        their_id: `${this.props.transaction_id}`,
        our_id: `${this.state.selected_id}`,
        source_id: this.props.reconciler.source_id
      }
    }
    this.reconcile_data.forId(this.props.reconciler.id).execute(data);
  }

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }

  render() {
    let list_recommended_resp = this.list_recommended.response();
    let rowsData = (list_recommended_resp.result && list_recommended_resp.result.rows) || [];
    let rowsMeta = list_recommended_resp.meta || {};
    let reconciler = this.props.reconciler || {};

    const { filter_query } = this.state;

    return <div>
      <Spin spinning={this.state.loading} tip="Reconciling...">
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          paddingLeft: 20,
          paddingRight: 20,
          alignItems: 'flex-end'
        }}>
          <FilterFixedInput label="Type">
            <Select
              allowClear
              className={filter_query.txn_type != null ? 'filter-option-selected' : ''}
              showSearch
              style={{
                marginRight: 8,
                width: '100%'
              }}
              // style={{ marginTop:4,marginBottom:4 }}
              placeholder="Type"
              value={filter_query.txn_type}
              // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onChange={(value, e) => {
                this.stateUpdater({
                  stateKey: 'filter_query',
                  valueKey: 'txn_type',
                  value: value,
                });
              }}
            >
              <Select.Option value={"D"} key={"D"}>
                Debit
                  </Select.Option>
              <Select.Option value={"C"} key={"C"}>
                Credit
                  </Select.Option>
              <Select.Option value={"N/A"} key={"N/A"}>
                N/A
                  </Select.Option>
            </Select>
          </FilterFixedInput>
          <CustomButton
            className='primary-btn'
            // style={{ marginLeft: 4, marginRight: 4 }}
            onClick={() => {
              this.list_recommended.config({
                params: {
                  ...this.state.filter_query,
                  per_page: 10,
                  page: 1
                }
              }).execute();
            }}
            label="FILTER"
          />

        </div>

        <Divider className='bg-divider' style={{
          marginTop: 12, marginBottom: 12
        }} />
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          paddingLeft: 20,
          paddingRight: 20,
          alignItems: 'center'
        }}>
          <span className='heading-2'>Recommended List</span>
          <div style={{
            display: 'flex',
            alignItems: 'center'
          }}>
            <CustomButton disabled={!this.state.selected_id}
              className='success-btn' onClick={() => {
                this.reconcileData()
              }}
              label="Reconcile"
            />
            <CustomButton style={{ marginLeft: 12 }} onClick={() => {
              this.setState({
                selected_id: null
              })
            }} className='danger-btn'
              disabled={!this.state.selected_id}

              label="Clear"
            />
          </div>
        </div>
        <Divider style={{
          marginTop: 12, marginBottom: 12
        }} />
        <Table
          scroll={{ x: true }}
          // title={() => <Row type='flex' justify='space-between'>
          //   <Title level={4} type='secondary'>Recommended List</Title>
          //   <span>
          //     <Button disabled={!this.state.selected_id} type='primary' onClick={() => {
          //       this.reconcileData()
          //     }}>Reconcile</Button>
          //     <Button style={{ marginLeft: 12 }} onClick={() => {
          //       this.setState({
          //         selected_id: null
          //       })
          //     }} type="danger" ghost disabled={!this.state.selected_id}>

          //       Clear
          //             </Button>
          //   </span>
          // </Row>}
          showHeader={false}
          size='small'
          rowKey={record => record.id}
          className='padding-top-table main-table no-separator-table'
          bordered={false}
          loading={list_recommended_resp.fetching}
          // showHeader={false}
          columns={recommended_cols({
            onViewDetailClicked: this.props.onViewDetailClicked,
            onAssignClick: (id, data) => {
              this.setState({ selected_id: id })
            },
            selected_id: this.state.selected_id
          })}
          pagination={{
            // simple: true,
            onChange: (current, size) => {
              this.list_recommended.config({
                params: {
                  ...filter_query,
                  per_page: size,
                  page: current
                }
              }).execute();
            },
            defaultCurrent: 1,
            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
            // defaultPageSize: 20,
            pageSize: (rowsMeta && rowsMeta.requested_count),

            total: (rowsMeta && rowsMeta.total_count),
            showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
          }}
          dataSource={rowsData}
        />

      </Spin>
    </div>
  }
  componentDidMount() {
    console.log("this props", this.props)
    if (!this.props.reconciled) {
      this.list_recommended.execute();
    }
  }
}

const UnclassifiedReconcilerForTransaction = withDomains(_UnclassifiedReconcilerForTransaction, "reconciliation", "allData");

class _ManualReconcileForTransaction extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      filter_query: {
        per_page: 10,
        page: 1,
        dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
        dateTo: moment().format(defaultDateFormat),
        amount: this.props.amount,
        source_id: this.props.reconciler.source_id,
        offset: 10
      }
    }
    this.list_unreconciled_data = RESTExecutor.list().config({
      label: props.reconciler.type === 'their' ? 'our_manual_unreconciled' : 'their_manual_unreconciled',
      params: {
        ...this.state.filter_query
      }
    }).callbacks((success) => {
    }, (error) => {
      showErrorInNotification(error);
    }).forId(props.reconciler_id).connect(props.domains.reconciliation);



    this.reconcile_data = RESTExecutor.post().config({
      label: 'reconcile_manually'
    }).forId(this.props.reconciler_id).callbacks((success) => {
      this.setState({ loading: false })
      message.success("Reconciled Successfully")
      typeof this.props.onRefresh === 'function' && this.props.onRefresh()
    }, (error) => {
      this.setState({ loading: false })
      showErrorInNotification(error)
    }).connect(props.domains.reconciliation);







    this.list_unreconciled_data.execute()

  }

  reconcileData = () => {
    this.setState({ loading: true });
    let data = {};
    if (this.props.reconciler.type == 'our') {
      data = {
        their_id: `${this.state.selected_id}`,
        our_id: `${this.props.transaction_id}`,
        source_id: this.props.reconciler.source_id
      }
    } else {
      data = {
        their_id: `${this.props.transaction_id}`,
        our_id: `${this.state.selected_id}`,
        source_id: this.props.reconciler.source_id
      }
    }
    this.reconcile_data.forId(this.props.reconciler_id).execute(data);
  }
  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }


  render() {
    let list_manual_resp = this.list_unreconciled_data.response();
    let rowsData = (list_manual_resp.result && list_manual_resp.result.rows) || [];
    let rowsMeta = list_manual_resp.meta || {};

    const { filter_query } = this.state;
    return <div>
      <Spin spinning={this.state.loading} tip="Reconciling...">

        <div style={{
          paddingLeft: 20,
          paddingRight: 20
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            flexWrap: 'nowrap',
            paddingTop: 4, paddingBottom: 12
          }}>
            <Input.Search
              placeholder="Input search text"
              // enterButton
              allowClear
              autoFocus
              value={filter_query.query}
              style={{}}
              onChange={(e) => {
                this.stateUpdater({
                  stateKey: 'filter_query', valueKey: 'query', value: e.target.value
                });
              }}
            />
            <CustomDateRangePicker
              style={{
                width: 400,
                marginLeft: 16,
                flex: null
              }}
              startDate={moment(filter_query.dateFrom, defaultDateFormat)}
              endDate={moment(filter_query.dateTo, defaultDateFormat)}
              onChange={(dates) => {
                this.stateUpdater({
                  stateKey: 'filter_query', appendObj: {
                    dateFrom: dates.startDate.format(defaultDateFormat),
                    dateTo: dates.endDate.format(defaultDateFormat)
                  }
                });
              }}

            />
          </div>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            // justifyContent: 'space-between',
            flexWrap: 'wrap',
            paddingTop: 4, paddingBottom: 4
          }}>
            <FilterFixedInput label="Type">
              <Select
                allowClear
                className={filter_query.txn_type != null ? 'filter-option-selected' : ''}
                showSearch
                style={{
                  // marginRight: 8,
                  width: '100%'
                }}
                // style={{ marginTop:4,marginBottom:4 }}
                placeholder="Type"
                value={filter_query.txn_type}
                // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                onChange={(value, e) => {
                  this.stateUpdater({
                    stateKey: 'filter_query',
                    valueKey: 'txn_type',
                    value: value,
                  });
                }}
              >
                <Select.Option value={"D"} key={"D"}>
                  Debit
                  </Select.Option>
                <Select.Option value={"C"} key={"C"}>
                  Credit
                  </Select.Option>
                <Select.Option value={"N/A"} key={"N/A"}>
                  N/A
                  </Select.Option>
              </Select>
            </FilterFixedInput>

            <FilterFixedInput label="Amount">
              <InputNumber
                placeholder="Amount"
                // className={filter_query.amount != null ? 'filter-option-selected' : ''}
                style={{
                  // margin: 4,
                  width: '100%'
                }}
                min={0}
                value={filter_query.amount} onChange={(value) => {
                  this.stateUpdater({
                    stateKey: 'filter_query',
                    valueKey: 'amount',
                    value: value,
                  })
                }} />
            </FilterFixedInput>
            <FilterFixedInput label="Offset">
              <InputNumber
                placeholder="Offset"
                style={{
                  // margin: 4,
                  width: '100%'
                }}
                min={0}
                value={filter_query.offset} onChange={(value) => {
                  this.stateUpdater({
                    stateKey: 'filter_query',
                    valueKey: 'offset',
                    value: value,
                  })
                }} />
            </FilterFixedInput>
          </div>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            // justifyContent: 'space-between',
            flexWrap: 'no-wrap',
            paddingTop: 16, paddingBottom: 12
          }}>
            <CustomButton
              className='primary-btn'
              style={{ marginLeft: 0 }}
              onClick={() => {
                this.list_unreconciled_data.config({
                  params: {
                    ...this.state.filter_query,
                    per_page: 10,
                    page: 1
                  }
                }).execute();
              }}
              label="FILTER"
            />

            <CustomButton
              className='danger-btn no-border'
              // style={{ marginLeft: 4, marginRight: 4 }}
              onClick={() => {
                this.setState({
                  filter_query: {
                    per_page: 10,
                    page: 1,
                    dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
                    dateTo: moment().format(defaultDateFormat),
                    amount: this.props.amount,
                    source_id: this.props.reconciler.source_id,
                    offset: 10
                  }
                }, () => {
                  this.list_unreconciled_data.config({
                    params: {
                      ...this.state.filter_query
                    }
                  }).execute()
                })
              }}
              label="CLEAR ALL"
            />
          </div>

        </div>

        {/* <div style={{
          border: '1px solid #ddd',
          borderRadius: 20,
          padding: 16,
          marginBottom: 8
        }}>
          <div style={{ display: 'flex', flexDirection: 'row', padding: 8 }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'right'
            }}>
              <Row style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                flexWrap: 'nowrap'
              }}>Date Range:&nbsp;
                <CustomDateRangePicker
                  style={{
                    margin: 4,
                    width: 400
                  }}
                  startDate={moment(filter_query.dateFrom, defaultDateFormat)}
                  endDate={moment(filter_query.dateTo, defaultDateFormat)}
                  onChange={(dates) => {
                    //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                    this.stateUpdater({
                      stateKey: 'filter_query', appendObj: {
                        dateFrom: dates.startDate.format(defaultDateFormat),
                        dateTo: dates.endDate.format(defaultDateFormat)
                      },
                      callback: () => {
                        // this.list_unreconciled_data.config({
                        //   params: {
                        //     ...this.state.filter_query,
                        //     per_page: 10,
                        //     page: 1
                        //   }
                        // }).execute()
                      }
                    });
                  }}
                />
              </Row>

              <span>Amount: &nbsp;
              <InputNumber
                  placeholder="Amount"
                  style={{
                    margin: 4,
                    width: 400
                  }}
                  min={0}
                  value={filter_query.amount} onChange={(value) => {
                    this.stateUpdater({
                      stateKey: 'filter_query',
                      valueKey: 'amount',
                      value: value,
                    })
                  }} />
              </span>
              <span>Source: &nbsp;
              <Select
                  allowClear
                  showSearch
                  style={{
                    margin: 4,
                    width: 400
                  }}
                  placeholder="Select Source"
                  value={filter_query.source_id}
                  filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  onChange={(value, e) => {
                    this.stateUpdater({
                      stateKey: 'filter_query',
                      valueKey: 'source_id',
                      value: value,
                    });
                  }}
                >
                  {source_list.map((item, index) => {
                    let ref = item.__references__ || {};
                    let source = ref.source_id || {};

                    return <Select.Option value={item.source_id} key={item.source_id}>
                      {source.name}
                    </Select.Option>
                  })}

                </Select>
              </span>
              <span>Offset: &nbsp;
              <InputNumber
                  placeholder="Offset"
                  style={{
                    margin: 4,
                    width: 400
                  }}
                  min={0}
                  value={filter_query.offset} onChange={(value) => {
                    this.stateUpdater({
                      stateKey: 'filter_query',
                      valueKey: 'offset',
                      value: value,
                    })
                  }} />
              </span>
              <span>Type: &nbsp;
              <Select
                  allowClear
                  showSearch
                  style={{
                    margin: 4,
                    width: 400
                  }}
                  // style={{ marginTop:4,marginBottom:4 }}
                  placeholder="Type"
                  value={filter_query.txn_type}
                  // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  onChange={(value, e) => {
                    this.stateUpdater({
                      stateKey: 'filter_query',
                      valueKey: 'txn_type',
                      value: value,
                    });
                  }}
                >
                  <Select.Option value={"D"} key={"D"}>
                    Debit
                  </Select.Option>
                  <Select.Option value={"C"} key={"C"}>
                    Credit
                  </Select.Option>
                  <Select.Option value={"N/A"} key={"N/A"}>
                    N/A
                  </Select.Option>
                </Select>

              </span>
            </div></div>

          <Row type='flex' justify='end'>
            <Button type='primary' size='small' style={{ marginLeft: 4, marginRight: 4 }}
              onClick={() => {
                this.list_unreconciled_data.config({
                  params: {
                    ...this.state.filter_query,
                    per_page: 10,
                    page: 1
                  }
                }).execute();
              }}
            >Filter</Button>
            <Button type='danger' size='small' onClick={() => {
              this.setState({
                filter_query: {
                  per_page: 10,
                  page: 1,
                  dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
                  dateTo: moment().format(defaultDateFormat),
                  amount: this.props.amount,
                  offset: 10
                }
              }, () => {
                this.list_unreconciled_data.config({
                  params: {
                    ...this.state.filter_query
                  }
                }).execute()
              })
            }}>Clear All</Button>
          </Row>
        </div> */}

        <Divider className='bg-divider' style={{
          marginTop: 12, marginBottom: 12
        }} />
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          paddingLeft: 20,
          paddingRight: 20,
          alignItems: 'center'
        }}>
          <span className='heading-2'>Transaction List</span>
          <div style={{
            display: 'flex',
            alignItems: 'center'
          }}>
            <CustomButton disabled={!this.state.selected_id}
              className='success-btn' onClick={() => {
                this.reconcileData()
              }}
              label="Reconcile"
            />
            <CustomButton style={{ marginLeft: 12 }} onClick={() => {
              this.setState({
                selected_id: null
              })
            }} className='danger-btn'
              disabled={!this.state.selected_id}

              label="Clear"
            />
          </div>
        </div>
        <Divider style={{
          marginTop: 12, marginBottom: 12
        }} />
        <Table
          scroll={{ x: true }}
          // title={() => <Row type='flex' justify='space-between'>
          //   <Title level={4} type='secondary'></Title>
          //   <span>
          //     <Button disabled={!this.state.selected_id} type='primary' onClick={() => {
          //       this.reconcileData()
          //     }}>Reconcile</Button>
          //     <Button style={{ marginLeft: 12 }} onClick={() => {
          //       this.setState({
          //         selected_id: null
          //       })
          //     }} type="danger" ghost disabled={!this.state.selected_id}>

          //       Clear
          //           </Button>
          //   </span>
          // </Row>}
          showHeader={false}
          size='small'
          className='padding-top-table main-table no-separator-table'
          bordered={false}
          loading={list_manual_resp.fetching}
          // showHeader={false}
          columns={recommended_cols({
            onViewDetailClicked: this.props.onViewDetailClicked,
            onAssignClick: (id, data) => {
              this.setState({ selected_id: id })
            },
            selected_id: this.state.selected_id
          })}
          pagination={{
            // simple: true,
            onChange: (current, size) => {
              this.stateUpdater({
                stateKey: 'filter_query',
                appendObj: {
                  per_page: size,
                  page: current
                },
                callback: () => {
                  this.list_unreconciled_data.config({
                    params: {
                      ...this.state.filter_query
                    }
                  }).execute();
                }
              })

            },
            defaultCurrent: 1,
            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
            // defaultPageSize: 20,
            pageSize: (rowsMeta && rowsMeta.requested_count),

            total: (rowsMeta && rowsMeta.total_count == 10001 ? 10000 : rowsMeta.total_count),
            showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${rowsMeta.total_count > 10000 ? `10,000+` : formatMoney(rowsMeta.total_count,0)} items`
          }}
          dataSource={rowsData}
        />
      </Spin>
    </div>
  }
}
const ManualReconcileForTransaction = withDomains(_ManualReconcileForTransaction, "reconciliation", "allData");




const recommended_cols = ({ onAssignClick, selected_id, onViewDetailClicked }) => [
  {
    // title: <center><Title level={4} type='secondary'>Recommended List</Title></center>,
    key: '',
    render: (item) => {
      return <TransactionReconcileItem
        isSelectable
        item_type='recommended'
        //   comparator_renderer={this.props.comparator_renderer}
        selectedID={selected_id}
        itemID={item.id}
        onViewDetailClicked={onViewDetailClicked}
        onSelected={(id, data) => {
          // this.setState({ selectedID: id }, () => {
          console.log("selected", id, data)
          typeof onAssignClick === 'function' && onAssignClick(id, data)
          // })
        }}
        data={item}
        key={item.id} />
    }
  }

]
class _RecommendedReconcileForTransaction extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      filter_query: {
        rule_id: this.props.rule_id || "",
        tran_id: this.props.transaction_id || "",
        source_id: this.props.reconciler.source_id,
        per_page: 10,
        page: 1
      }
    }

    this.list_recommended = RESTExecutor.list().config({
      label: 'recommended_for_rules',
      params: {
        ...this.state.filter_query,
      }
    }).callbacks(() => { }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.reconciliation);

    this.reconcile_data = RESTExecutor.post().config({
      label: 'reconcile_manually'
    }).forId(this.props.reconciler.id).callbacks((success) => {
      this.setState({ loading: false })
      message.success("Reconciled Successfully")
      typeof this.props.onRefresh === 'function' && this.props.onRefresh()
    }, (error) => {
      this.setState({ loading: false })
      showErrorInNotification(error)
    }).connect(props.domains.reconciliation);




    // let reconciler = this.props.reconciler || {};
    // if (reconciler.type === 'their') {
    //   this.list_sources_fordatatype.forId(reconciler.our_data_type_id).execute();
    // } else {
    //   this.list_sources_fordatatype.forId(reconciler.their_data_type_id).execute();
    // }

  }

  reconcileData = () => {
    this.setState({ loading: true });
    let data = {};
    if (this.props.reconciler.type == 'our') {
      data = {
        their_id: `${this.state.selected_id}`,
        our_id: `${this.props.transaction_id}`,
        source_id: this.props.reconciler.source_id
      }
    } else {
      data = {
        their_id: `${this.props.transaction_id}`,
        our_id: `${this.state.selected_id}`,
        source_id: this.props.reconciler.source_id
      }
    }
    this.reconcile_data.forId(this.props.reconciler.id).execute(data);
  }

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }

  render() {
    let list_recommended_resp = this.list_recommended.response();
    let reconciler = this.props.reconciler || {};

    let rowsData = (list_recommended_resp.result && list_recommended_resp.result.rows) || [];
    let rowsMeta = list_recommended_resp.meta || {};
    const { filter_query } = this.state;

    return <div>
      <Spin spinning={this.state.loading} tip="Reconciling...">
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          paddingLeft: 20,
          paddingRight: 20,
          alignItems: 'flex-end'
        }}>
          <FilterFixedInput label="Type">
            <Select
              allowClear
              className={filter_query.txn_type != null ? 'filter-option-selected' : ''}
              showSearch
              style={{
                marginRight: 8,
                width: '100%'
              }}
              // style={{ marginTop:4,marginBottom:4 }}
              placeholder="Type"
              value={filter_query.txn_type}
              // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onChange={(value, e) => {
                this.stateUpdater({
                  stateKey: 'filter_query',
                  valueKey: 'txn_type',
                  value: value,
                });
              }}
            >
              <Select.Option value={"D"} key={"D"}>
                Debit
                  </Select.Option>
              <Select.Option value={"C"} key={"C"}>
                Credit
                  </Select.Option>
              <Select.Option value={"N/A"} key={"N/A"}>
                N/A
                  </Select.Option>
            </Select>
          </FilterFixedInput>
          <CustomButton
            className='primary-btn'
            // style={{ marginLeft: 4, marginRight: 4 }}
            onClick={() => {
              this.list_recommended.config({
                params: {
                  ...this.state.filter_query,
                  per_page: 10,
                  page: 1
                }
              }).execute();
            }}
            label="FILTER"
          />

        </div>

        <Divider className='bg-divider' style={{
          marginTop: 12, marginBottom: 12
        }} />
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          paddingLeft: 20,
          paddingRight: 20,
          alignItems: 'center'
        }}>
          <span className='heading-2'>Recommended List</span>
          <div style={{
            display: 'flex',
            alignItems: 'center'
          }}>
            <CustomButton disabled={!this.state.selected_id}
              className='success-btn' onClick={() => {
                this.reconcileData()
              }}
              label="Reconcile"
            />
            <CustomButton style={{ marginLeft: 12 }} onClick={() => {
              this.setState({
                selected_id: null
              })
            }} className='danger-btn'
              disabled={!this.state.selected_id}

              label="Clear"
            />
          </div>
        </div>
        <Divider

          style={{
            marginTop: 12, marginBottom: 12
          }} />
        {/* <div style={{
          border: '1px solid #ddd',
          borderRadius: 20,
          padding: 16,
          marginBottom: 8
        }}>
          <div style={{ display: 'flex', flexDirection: 'row', padding: 8 }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'right'
            }}>
              <span>Source: &nbsp;
              <Select
                  allowClear
                  showSearch
                  style={{
                    margin: 4,
                    width: 400
                  }}
                  placeholder="Select Source"
                  value={filter_query.source_id}
                  filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  onChange={(value, e) => {
                    this.stateUpdater({
                      stateKey: 'filter_query',
                      valueKey: 'source_id',
                      value: value,
                    });
                  }}
                >
                  {source_list.map((item, index) => {
                    let ref = item.__references__ || {};
                    let source = ref.source_id || {};

                    return <Select.Option value={item.source_id} key={item.source_id}>
                      {source.name}
                    </Select.Option>
                  })}

                </Select>
              </span>
              <span>Type: &nbsp;
              <Select
                  allowClear
                  showSearch
                  style={{
                    margin: 4,
                    width: 400
                  }}
                  // style={{ marginTop:4,marginBottom:4 }}
                  placeholder="Type"
                  value={filter_query.txn_type}
                  // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  onChange={(value, e) => {
                    this.stateUpdater({
                      stateKey: 'filter_query',
                      valueKey: 'txn_type',
                      value: value,
                    });
                  }}
                >
                  <Select.Option value={"D"} key={"D"}>
                    Debit
                  </Select.Option>
                  <Select.Option value={"C"} key={"C"}>
                    Credit
                  </Select.Option>
                  <Select.Option value={"N/A"} key={"N/A"}>
                    N/A
                  </Select.Option>
                </Select>

              </span>
            </div></div>

          <Row type='flex' justify='end'>
            <Button type='primary' size='small' style={{ marginLeft: 4, marginRight: 4 }}
              onClick={() => {
                this.list_recommended.config({
                  params: {
                    ...this.state.filter_query,
                    per_page: 10,
                    page: 1
                  }
                }).execute();
              }}
            >Filter</Button>
          </Row>
        </div> */}
        <Table
          scroll={{ x: true }}
          // title={() => <Row type='flex' justify='space-between'>
          //   <Title level={4} type='secondary'>Recommended List</Title>
          //   <span>
          //     <Button disabled={!this.state.selected_id} type='primary' onClick={() => {
          //       this.reconcileData()
          //     }}>Reconcile</Button>
          //     <Button style={{ marginLeft: 12 }} onClick={() => {
          //       this.setState({
          //         selected_id: null
          //       })
          //     }} type="danger" ghost disabled={!this.state.selected_id}>

          //       Clear
          //             </Button>
          //   </span>
          // </Row>}
          showHeader={false}
          size='small'
          rowKey={record => record.id}
          className='padding-top-table main-table no-separator-table'
          bordered={false}
          loading={list_recommended_resp.fetching}
          // showHeader={false}
          columns={recommended_cols({
            onViewDetailClicked: this.props.onViewDetailClicked,
            onAssignClick: (id, data) => {
              this.setState({ selected_id: id })
            },
            selected_id: this.state.selected_id
          })}
          pagination={{
            // simple: true,
            onChange: (current, size) => {
              this.list_recommended.config({
                params: {
                  ...filter_query,
                  per_page: size,
                  page: current
                }
              }).execute();
            },
            defaultCurrent: 1,
            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
            // defaultPageSize: 20,
            pageSize: (rowsMeta && rowsMeta.requested_count),

            total: (rowsMeta && rowsMeta.total_count),
            showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
          }}
          dataSource={rowsData}
        />
      </Spin>
    </div>
  }
  componentDidMount() {
    console.log("this props", this.props)
    if (!this.props.reconciled) {
      this.list_recommended.execute();
    }
  }
}
const RecommendedReconcileForTransaction = withDomains(_RecommendedReconcileForTransaction, "reconciliation", "allData");


class _AddMorePeers extends React.Component {
  constructor(props) {
    super(props)

    this.state = {

    }
  }

  render() {
    return <div>
      adding peers
    </div>
  }
}
const AddMorePeers = withDomains(_AddMorePeers, "reconciliation", "allData");


class _BatchPeersView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      filter_query:{
        txn_id: this.props.transaction_id,
        per_page:10
      }
    }

    this.transaction_id = this.props.transaction_id;
    this.reconciler_id = this.props.reconciler_id;
    this.reconciler = this.props.reconciler || {};

    this.list_peers = RESTExecutor.list().config({
      label: 'list_batch_v2',
      params: {
        ...this.state.filter_query
      }
    }).forId(props.reconciler_id).connect(props.domains.batching);

    this.list_peers.execute();


  }

  render() {
    let list_peers_resp = this.list_peers.response();
    let list_peers_data = list_peers_resp.result || {};
    let rowsData = list_peers_data.rows || []
    let rowsMeta=list_peers_resp.meta||{}

    return <div className='default-card' style={{
      margin: 0,
      marginBottom: 12
    }}>
      <ErrorWrapper
        error={list_peers_resp}
        onReload={() => {
          this.list_peers.execute()
        }}
        no_back_action={true}
      >
        <React.Fragment>
          {/* <Title level={3} >Peers For {this.reconciler.name}</Title> */}

          <Table
            scroll={{
              x: true
            }}
            className='main-table'
            loading={list_peers_resp.fetching}
            size='small'
            dataSource={rowsData}
            title={() => {
              return <Row type='flex'>
                <span className='sub-heading-2' style={{
                  marginLeft: 8
                }}>PEERS FOR {this.reconciler.name}</span>
              </Row>
            }}
            columns={peers_cols({
              onViewDetailClicked: this.props.onViewDetailClicked
            })}
            pagination={{
              size:'small',
              onChange:(current, size) => {

                this.list_peers.config({
                  params:{
                    txn_id: this.transaction_id,
                    page:current
                  }
                }).execute()

              },
              defaultCurrent:1,
              current:rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
              pageSize:(rowsMeta && rowsMeta.requested_count),
              total:(rowsMeta && rowsMeta.total_count),
              showTotal:(total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`,
            }}
          />
        </React.Fragment>
      </ErrorWrapper>

    </div>
  }
}
const BatchPeersView = withDomains(_BatchPeersView, "batching")


const peers_cols = ({ onViewDetailClicked, onRemoveClicked }) => [
  {
    title: "Type",
    dataIndex: "type",
    width: 53,
    key: 'type',
    render: (value) => <div
      title={value == 'C' ? "Credit" : (value == 'D' ? "Debit" : "N/A")} className={value === 'D' ? 'debit-circle' : value == 'C' ? 'credit-circle' : 'na-circle'}
    >
      {value}
    </div>
  },
  {
    title: "Txn Date",
    dataIndex: "txn_date",
    width: 100,
    key: 'txn_date'
  }, {
    title: "Tran ID",
    dataIndex: "transaction_id",
    width: 100,
    key: 'transaction_id'
  }, {
    title: "Particular",
    dataIndex: "description",
    key: 'description'
  }, {
    title: "Amount",
    dataIndex: "amount",
    width: 120,
    key: 'amount',
    render: (amount = 0) => formatMoney(amount, 2, '.', ',')
  },
  {
    title: "",
    dataIndex: "id",
    width: 50,
    key: 'action',
    render: (id) => <MoreHorizOutlined
      titleAccess='View Detail'
      className='basic-icon hand-cursor' onClick={() => {
        typeof onViewDetailClicked === 'function' && onViewDetailClicked(id)
      }} />
  }
]